import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class TeminatPopupApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/TeminatPopup',
      requesterInfo,
    })
  }

  public async teminatPopup(): Promise<any> {
    return await this.getAsync<any>()
  }
}
